import React, { memo } from 'react';
import { useLocation } from 'react-router-dom';
import classNames from 'classnames';

import config from '../../config';

import style from './style.module.css';

const AppSwitcherComponent = () => {
  const { pathname, search, hash } = useLocation();

  return (
    <div className={classNames('alert alert-info', style.host)}>
      <span>This is the updated version of Harvey CRM, if you want to back to the previous version, click here</span>
      <a className="btn btn-default" href={`${config.PREVIOUS_VERSION_URL}${pathname}${search}${hash}`}>
        Back to the previous version
      </a>
    </div>
  );
};

/**
 * Header banner with a link to the same route in the previous version of the CRM.
 */
export const AppSwitcher = memo(AppSwitcherComponent);
